import {useCallback, useEffect, useState} from "react";
import styles from "./style.module.css";
import {motion} from 'framer-motion';
import {LANGUAGE} from "../../enviroment";

const LEGAL_CONSENT_KEY = 'legal_consent_status';

const LegalModal = () => {

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [show]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            const cookieConsent = localStorage.getItem(LEGAL_CONSENT_KEY);
            if (cookieConsent == null) {
                setShow(LANGUAGE === 'cz')
            } else if (localStorage.getItem(LEGAL_CONSENT_KEY) == 'accepted') {
                setShow(false);
            }
        }, 500);
        return () => clearTimeout(timeout);
    }, []);

    const onAccept = useCallback(() => {
        localStorage.setItem(LEGAL_CONSENT_KEY, 'accepted');
        setShow(false);
    }, []);


    return show && (
        <motion.div className={styles.modalOverlay}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
        >
            <motion.div className={styles.modalContainer}
                        initial={{scale: 0.9, opacity: 0}}
                        animate={{scale: 1, opacity: 1}}
                        exit={{scale: 0.9, opacity: 0}}>

                <div className={styles.modalContent}>
                    <h3 className={styles.modalTitle}>Jste odborný pracovník ve zdravotnictví?</h3>
                    <p className={styles.modalText}>
                        Odborník ve smyslu §2a Zákona č. 40/1995 Sb., o regulaci reklamy, ve znění pozdějších předpisů, je osobou oprávněnou předepisovat nebo vydávat léčivé přípravky či zdravotnické prostředky nebo osobou oprávněnou poskytovat zdravotní péči.<br/><br/>
                        Potvrzením prohlašuji, že jsem odborník dle výše uvedené definice.
                    </p>

                    <div className={styles.modalButtons}>
                        <button onClick={onAccept}>Potvrdit a vstoupit</button>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default LegalModal;